export function handleBgImage(imgElem, elem) {
    var img = $(imgElem).find('img').first();
    if (!img.length) return; // no image found, bail out

    var src = img.attr('src'),
        url = "url('" + src + "')";

    $(elem).css('background-image', url);
    img.addClass('sr-only');

    if (img.parent().prop('nodeName') === 'P') {
        img.unwrap();
    }
}

$(function () {
    $('.bg-image, .promo-block').each(function () {
        handleBgImage($(this), $(this));
    });
});